import {
  getOverviewData,
  updatePlansAndTarget,
  deletePlan,
} from "../handler/ParentDataHandler";
import { getStationCode } from "../network/NetworkUtil";
import {
  days,
  MODAL_SUCCESS,
  MODAL_ERROR,
  RESET_TIME_OVERLAP,
  MISSING_MANDATORY_FIELD,
} from "./SettingsConstant";
import {
  formatGetPlanDetails,
  validCyclePlan,
  isValidPlanAndAccordanceWithStationResetTime,
} from "./SettingsUtil";

/**
 * API to fetch settingsInsight
 * @param dispatcher
 */
export function fetchSettingsInsight(dispatcher) {
  const request = {
    stationCode: getStationCode(),
    processName: "settings",
  };
  getSettingsInsights(dispatcher, request);
}

async function getSettingsInsights(dispatcher, request) {
  const args = {
    processName: "station-plan",
    queryParams: "stationCode=" + request.stationCode,
  };
  getOverviewData(args).then((result) => {
    if (result.status === 200) {
      if (result.data) {
        const settingsInsights = formatGetPlanDetails(result.data);
        dispatcher({
          type: "SETTINGS_INSIGHT",
          data: {
            settingsData: settingsInsights,
          },
        });
      }
    }
  });
}

function updateSettingsInsightRequest(data, day) {
  let request = {};
  request.planDetails = data.planDetails ? data.planDetails : {};
  request.nodeTargets = data.targetMap ? data.targetMap : {};
  request.taskPlan = data.taskPlan ? data.taskPlan : {};
  request.breaks = data.breaks ? data.breaks : {};
  request.dayOfTheWeekList = [day];
  return request;
}

/**
 * API to update settingsInsight
 * @param state
 */

export function updateSettingsInsight(state) {
  days.forEach((day) => {
    if (state.settingsData[day]) {
      state.settingsData[day].forEach((data) => {
        if (validCyclePlan(data)) {
          const request = updateSettingsInsightRequest(data, day);
          updatePlansAndTarget(request);
        }
      });
    }
  });
}

function updatePlanRequest(state, plan) {
  let request = {};
  days.forEach((day) => {
    if (state.settingsData[day]) {
      state.settingsData[day].forEach((data) => {
        if (data === plan) {
          request.dayOfTheWeekList = [day];
        }
      });
    }
  });

  request.planDetails = plan.planDetails ? plan.planDetails : {};
  request.nodeTargets = plan.targetMap ? plan.targetMap : {};
  request.taskPlan = plan.taskPlan ? plan.taskPlan : {};
  request.breaks = plan.breaks ? plan.breaks : {};
  return request;
}

/**
 * API to update plan
 * @param state
 */
export async function updateSelectedPlan(state, dispatcher, plan) {
  const request = updatePlanRequest(state, plan);
  if (validCyclePlan(plan)) {
    if (isValidPlanAndAccordanceWithStationResetTime(plan)) {
      updatePlansAndTarget(request).then((result) => {
        if (result.status === 200) {
          if (result.data && result.data.statusCode === "OK") {
            dispatcher({
              type: "UPDATE_PLAN_RESPONSE",
              data: {
                showUpdatePlanResponseModal: MODAL_SUCCESS,
                plan: plan,
                message: "plan_updated_successfully",
              },
            });
          } else {
            dispatcher({
              type: "UPDATE_PLAN_RESPONSE",
              data: {
                showUpdatePlanResponseModal: MODAL_ERROR,
                plan: plan,
                message: result.data.errorMessage,
              },
            });
          }
        }
      });
    } else {
      dispatcher({
        type: "UPDATE_PLAN_RESPONSE",
        data: {
          showUpdatePlanResponseModal: MODAL_ERROR,
          plan: plan,
          message: RESET_TIME_OVERLAP,
        },
      });
    }
  } else {
    dispatcher({
      type: "UPDATE_PLAN_RESPONSE",
      data: {
        showUpdatePlanResponseModal: MODAL_ERROR,
        plan: plan,
        message: MISSING_MANDATORY_FIELD,
      },
    });
  }
}

function deletePlanRequest(plan) {
  let request = {};
  request.dayOfTheWeek = plan.dayOfTheWeek;
  request.cycleId = plan.planDetails.cycleId;
  request.cycleName = plan.planDetails.cycleName;
  return request;
}

/**
 * API to delete plan
 * @param state
 */
export async function deleteSelectedPlan(dispatcher, state) {
  const request = deletePlanRequest(state);
  deletePlan(request).then((result) => {
    if (result.status === 200) {
      if (result.data && result.data.statusCode === "OK") {
        dispatcher({
          type: "DELETE_PLAN_RESPONSE",
          data: {
            showDeletePlanResponseModal: MODAL_SUCCESS,
            plan: state,
            message: "plan_deleted_successfully",
          },
        });
      } else {
        dispatcher({
          type: "DELETE_PLAN_RESPONSE",
          data: {
            showDeletePlanResponseModal: MODAL_ERROR,
            plan: state,
            message: "error_deleting_plan",
          },
        });
      }
    }
  });
}



// WEBPACK FOOTER //
// ./src/components/settings/settingsNetworkAPI.js